import moment from 'moment-timezone';

export const canSelectDateFactory = (start: moment.Moment): ((end: moment.Moment) => boolean) => {
  const end = moment();
  return date => !date.isBetween(start, end, 'day', '[]');
};
